// src/services/promoCodeService.js
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

/**
 * Whether any promo campaign is currently redeemable. Used to decide if a fresh
 * signup with no ?promo link should still be prompted to enter a code manually.
 * Returns false on any error so we simply don't prompt.
 */
export async function hasActivePromoCampaigns() {
  try {
    const fn = httpsCallable(functions, "getActivePromoCampaigns");
    const res = await fn({});
    return Number(res?.data?.count || 0) > 0;
  } catch {
    return false;
  }
}

/**
 * Read-only offer preview for the redeem modal. Returns the customer-facing
 * offer (title, description, points, validity, alreadyRedeemed, redeemable)
 * without awarding anything.
 */
export async function previewPromoCode(code = "") {
  const fn = httpsCallable(functions, "previewPromoCode");
  const res = await fn({ code: String(code || "").trim() });
  return res?.data || { ok: false };
}

/**
 * Validate + award a promo code (idempotent server-side). Returns
 * { ok, code, awardedPoints, mintedKeys, balances, redeemThreshold }.
 */
export async function redeemPromoCode(code = "") {
  const fn = httpsCallable(functions, "redeemPromoCode");
  const res = await fn({ code: String(code || "").trim() });
  return res?.data || { ok: false };
}
